import CreditCardIcon from '@mui/icons-material/CreditCard';
import React from 'react';
import { Modal, Stack, Text, CircularProgress } from '@/theme/components';

/**
 * This component is a generic modal used to display a spinner and to prevent the user from interacting with the app
 * while the payment is being processed.
 */
export const ProcessingSpinnerModal = ({
  open,
  onClose,
}: {
  /** If true, the modal is open */
  open: boolean;
  /**
   * Callback fired when the user tries to close the modal by either
   * clicking on the backdrop or by pressing the escape key
   */
  onClose?: () => void;
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Stack padding={12} gap={1} alignItems="center">
        <CircularProgress
          variant="indeterminate"
          size={96}
          disableShrink
          sx={{
            color: (theme) => theme.palette.primary.main,
            position: 'absolute',
            animationDuration: '550ms',
            zIndex: 1,
          }}
          thickness={2}
        />
        <CircularProgress
          variant="determinate"
          sx={{
            color: (theme) => theme.palette.secondary.main,
            position: 'absolute',
          }}
          size={96}
          thickness={2}
          value={100}
        />
        <Stack
          alignItems="center"
          justifyContent="center"
          width={96}
          height={96}
        >
          <CreditCardIcon
            sx={(theme) => ({
              width: theme.spacing(6),
              height: theme.spacing(6),
            })}
            color="primary"
          />
        </Stack>
        <Text variant="h4">Processing</Text>
      </Stack>
    </Modal>
  );
};
